export const PROFILE_DROPDOWN: any[] = [
  {
    title: 'Edit Profile',
    icon: 'user',
    id: 'view-account',
    action: '/settings?view=account'
  },
  {
    title: 'Email Preferences',
    icon: 'lock',
    id: 'view-email-preferences',
    action: '/settings?view=email-pref'
  },
  {
    title: 'Logout',
    icon: 'home',
    id: 'logout',
    action: 'logout'
  }
];
export const RESEARCH_DROPDOWN: any[] = [
  {
    title: 'Vehicle Rankings',
    action: '/rankings'
  },
  {
    title: 'Blog',
    action: '/blog'
  }
];
